import api from '../../../../api/client'

function normalizeItems(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  return []
}

export async function fetchLeaveApprovalQueue(params = {}) {
  const { data } = await api.get('/leaves/approval-queue', {
    params: {
      page: 1,
      page_size: 10,
      ...params,
    },
  })
  return data || { items: [], page: 1, pageSize: 10, hasMore: false, total: 0 }
}

export async function fetchLeaveApprovalUsers(params = {}) {
  const { data } = await api.get('/leaves/approval-options/users', { params })
  return normalizeItems(data)
}

export async function approveLeave(leaveId) {
  const { data } = await api.patch(`/leaves/${leaveId}/approve`)
  return data || {}
}

export async function rejectLeave(leaveId, payload = {}) {
  const { data } = await api.patch(`/leaves/${leaveId}/reject`, payload)
  return data || {}
}

export async function bulkApproveLeaves(payload) {
  const { data } = await api.patch('/leaves/bulk-approve', payload)
  return data || {}
}

export async function bulkRejectLeaves(payload) {
  const { data } = await api.patch('/leaves/bulk-reject', payload)
  return data || {}
}
